import './assets/CartCardComponent.css';const t = "#ffffff", a = "#396e75", o = "#e5fdff", r = "#546223", l = "#f0fae5", e = "#a65523", n = "#fff1e8", i = "#7f3e3e", d = "#ffe2e2", s = "#62625a", c = "#f8f8e7", _ = "#38539a", u = "#707070", p = "#c8f8d1", g = "#87c9c8", f = "#5291b1", k = "rgba(82, 145, 177, 0.1019607843)", z = "#445685", V = "#181d61", h = "rgba(24, 29, 97, 0.1019607843)", C = "#5969d6", y = "#ea999d", m = "#b6577e", b = "rgba(182, 87, 126, 0.1019607843)", w = "#7e3e80", x = "#1e247f", v = "rgba(30, 36, 127, 0.1019607843)", B = "#da7600", G = "#107f47", O = "#d91734", j = "_html_plu52_75", R = {
  amwayWhite: t,
  darkBlue: a,
  lightBlue: o,
  darkGreen: r,
  lightGreen: l,
  darkOrange: e,
  lightOrange: n,
  darkRed: i,
  lightRed: d,
  darkYellow: s,
  lightYellow: c,
  darkPurple: _,
  darkGrayOnWhite: u,
  dataVizColor1: p,
  dataVizColor2: g,
  dataVizColor3: f,
  dataVizColor3Background: k,
  dataVizColor4: z,
  dataVizColor5: V,
  dataVizColor5Background: h,
  dataVizColor6: C,
  dataVizColor7: y,
  dataVizColor8: m,
  dataVizColor8Background: b,
  dataVizColor9: w,
  dataVizColor10: x,
  dataVizColor10Background: v,
  dataVizAlertOrange: B,
  dataVizSuccessGreen: G,
  dataVizWarningRed: O,
  "no-visible": "_no-visible_plu52_34",
  html: j,
  "tag-container": "_tag-container_plu52_142",
  "promotion-tag": "_promotion-tag_plu52_148",
  "product-card-entry-heart-icon": "_product-card-entry-heart-icon_plu52_161",
  "product-card-entry": "_product-card-entry_plu52_161",
  "cart-product-info": "_cart-product-info_plu52_166",
  "cart-product-checkbox-container": "_cart-product-checkbox-container_plu52_177",
  "card-image": "_card-image_plu52_186",
  "image-link": "_image-link_plu52_193",
  "card-details": "_card-details_plu52_199",
  "cancel-container": "_cancel-container_plu52_204",
  "wishlist-container": "_wishlist-container_plu52_219",
  "card-description": "_card-description_plu52_228",
  "left-panel-installments": "_left-panel-installments_plu52_236",
  "right-panel-installments": "_right-panel-installments_plu52_240",
  "left-panel": "_left-panel_plu52_236",
  "order-details": "_order-details_plu52_280",
  "right-panel": "_right-panel_plu52_240",
  "stock-status-top": "_stock-status-top_plu52_287",
  "stock-status-date-subtext": "_stock-status-date-subtext_plu52_292",
  "stock-status-subtext": "_stock-status-subtext_plu52_293",
  "cpw-variant-cart-container": "_cpw-variant-cart-container_plu52_300",
  "cart-variant-btn": "_cart-variant-btn_plu52_306",
  "button-status-container": "_button-status-container_plu52_309",
  "justify-flex-end": "_justify-flex-end_plu52_318",
  "justify-flex-end-no-margin": "_justify-flex-end-no-margin_plu52_322",
  "remove-wishlist-container": "_remove-wishlist-container_plu52_325",
  "add-to-cart-btn": "_add-to-cart-btn_plu52_332",
  "remove-margin": "_remove-margin_plu52_338",
  "stock-status-toggle": "_stock-status-toggle_plu52_341",
  "quantity-label-padding": "_quantity-label-padding_plu52_346",
  "delete-container": "_delete-container_plu52_349",
  "cart-disposition-status": "_cart-disposition-status_plu52_357",
  "cart-inventory-status": "_cart-inventory-status_plu52_360",
  "product-card-entry-mobile": "_product-card-entry-mobile_plu52_367",
  "adjust-style": "_adjust-style_plu52_385",
  "full-width": "_full-width_plu52_395",
  "display-flex-style": "_display-flex-style_plu52_449",
  "display-flex-row": "_display-flex-row_plu52_455"
};
export {
  R as s
};
//# sourceMappingURL=CartCardComponent.module-5e6fddd4.mjs.map
